import UIInput from "../UIInput";

export default UIInput;
